import { ApiMessage } from '@/api/api'
export default {
    data() {
        return {
            getItemListStart: true,
            limit: 20,
            pageN: 1
        }
    },
    computed: {
        getOffset() {
            return this.limit * (this.pageN - 1)
        },
        params() {
            return {
                offset: this.getOffset,
                limit: this.limit
            }
        },

        requestData() {
            return {
                params: {
                    offset: this.getOffset,
                    limit: this.limit
                }
            }
        }
    },
    created() {
        this.$root.$on('resetHistory', this.resetHistory)
    },
    beforeDestroy() {
        this.$root.$off('resetHistory', this.resetHistory)
    },
    methods: {
        resetHistory(promise) {
            this.$store.commit('chat/resetState')
            this.pageN = 1
            this.getItemListStart = true
            this.getItemList().then(() => {
                setTimeout(() => {
                    promise.resolve(true)
                    this.scrollbarScrollerPush(this.$refs.scrollbar)
                }, 500)
            })
        },
        getItemList() {
            return new Promise((resolve, reject) => {
                if (!this.getItemListStart) return
                this.getItemListStart = false

                ApiMessage.history(this.requestData.params).then(({ data: response }) => {
                    this.$root.$emit('emitHistoryIsLoadForScenarioAfterInit') //при отложенном ините, надо сначало сделать инит, потом загрузить историю, и только потом что бы сработал сценарий, для этого нужно

                    if (!response.length) return resolve()
                    this.getItemListStart = true
                    response.forEach(item => {
                        item.time = parseInt(item.time)
                        item.id = parseInt(item.id)
                    })

                    response.sort((a, b) => a.id - b.id) // b - a for reverse sort

                    response = response.filter(
                        message =>
                            !this.$store.state.chat.messages.some(item => item.id === message.id)
                    ) //убираем дубликаты

                    this.$store.commit('chat/messagesuUnshift', response)
                    this.scrollTopBeforeAddContent = this.$refs.scrollbar.$el.scrollTop

                    this.pageN += 1

                    resolve()
                })
            })
        }
    }
}
